import { useState } from "react";
import { Link, useMatch, useResolvedPath } from "react-router-dom";

function Navbar() {
    const [isResponsive, setIsResponsive] = useState(false);

    const toggleMenu = () => {
        setIsResponsive(!isResponsive);
    };

    // Close menu when a link is clicked (optional but good UX)
    const handleLinkClick = () => {
        setIsResponsive(false);
    };

    return (
        <div className={`topnav ${isResponsive ? 'responsive' : ''}`}>
            <CustomLink to={"/"} onClick={handleLinkClick}>Home</CustomLink>
            <CustomLink to={"/Experience"} onClick={handleLinkClick}>Experience</CustomLink>
            <CustomLink to={"/Projects"} onClick={handleLinkClick}>Projects</CustomLink>
            <CustomLink to={"/CV"} onClick={handleLinkClick}>CV/Resume</CustomLink>
            <CustomLink to={"/CVShort"} onClick={handleLinkClick}>Short CV</CustomLink>
            <a href="#" className="icon" onClick={(e) => { e.preventDefault(); toggleMenu(); }}>
                <i className="fa fa-bars"></i>
            </a>
        </div>
    );
}

function CustomLink({ to, children, ...props }) {
    const resolvedPath = useResolvedPath(to);
    const isActive = useMatch({ path: resolvedPath.pathname, end: true });
    return (
        <Link to={to} {...props} className={isActive ? "active" : ""}>
            {children}
        </Link>
    );
}

export default Navbar;